import { useMemo } from 'react';
import WithCompareSort from './WithCompareSort';
import WithoutCompareSort from './WithoutCompareSort';

function SimulationSort(
    sortType: SortType,
    processedData: SimulationPerformanceTableItem[],
    chartType: RulePerformanceChartType,
    deployedData: SimulationPerformanceTableItem[]
) {
    const chartTypeWiseSort = processedData.filter((obj) => obj?.chartType === chartType);
    const simulationSortData = useMemo(() => {
        return processedData?.length && deployedData?.length
            ? WithCompareSort(sortType, chartTypeWiseSort)
            : WithoutCompareSort(sortType, chartTypeWiseSort);
    }, [processedData, deployedData, sortType, chartTypeWiseSort]);
    return simulationSortData;
}
export default SimulationSort;
